import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CmsEntities } from 'client/data/models/cms';

import { getStaticImageUrl } from 'client/utils/image-helpers';
import { Link } from 'site-modules/shared/components/link/link';
import { AdLabel } from 'site-modules/shared/components/native-ad/native-ad-components/ad-label/ad-label';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';
import './research-by-type.scss';

const DEVICE = {
  true: 'Mobile',
  false: 'Wired',
};
const OEM = 'oemClickOut';
function getParams(type, isMobile) {
  if (type.metadata('adType').boolean()) {
    return {
      url: type.metadata(`${OEM}Url${DEVICE[isMobile]}`).value(),
      text: type.metadata(`${OEM}Text${DEVICE[isMobile]}`).value(),
    };
  }
  return { url: type.metadata('url').value(), text: type.title };
}
export function ResearchByType({ content, className = null, isMobile = false }) {
  const { title, summary } = content;
  const showIconPower = content.metadata('showIconPower').boolean();
  const types = content.children();

  return (
    <Container data-tracking-parent="edm-entry-type-center" className={classnames('ev-research-by-type', className)}>
      <div className="content bg-white rounded-12 px-1_25 py-2_5">
        <Row>
          <Col xs={12} md={4} className="mb-2_5">
            <h2 className="heading-3">
              {showIconPower && <i className="icon-power2 me-0_25 size-20 d-inline-block" aria-hidden />}
              {title}
            </h2>
            <div>{summary}</div>
          </Col>
          <Col
            xs={12}
            md={8}
            className="types ps-md-2 d-flex justify-content-between flex-wrap vertical flex-lg-nowrap"
          >
            {types.map(type => {
              const { url, text } = getParams(type, isMobile);
              const { titleClassName, imageUrl, adNameWired, adNameMobile } = type.getAllMetadata();
              const adType = type.metadata('adType').boolean();
              return (
                <Link
                  key={url}
                  to={url}
                  target={adType ? '_blank' : '_self'}
                  data-tracking-id="type_select"
                  data-tracking-value={text}
                  className="type overflow-hidden bg-blue-100 rounded-12 w-100 d-flex align-items-center justify-content-between pos-r pt-1_25 pb-1_5 px-0_5 flex-column text-center"
                >
                  {adType && <AdLabel styles={{ top: 0, left: 0, right: 'auto', height: '17px' }} />}
                  <span className={classnames('fw-bold mb-0_75', titleClassName)}>{text}</span>
                  <img src={getStaticImageUrl(imageUrl)} alt="" className="w-100" />
                  {adType && (
                    <div className="pos-a">
                      <AdUnit
                        adName={isMobile ? adNameMobile : adNameWired}
                        position={'1'}
                        all
                        renderWhenViewable={false}
                        refreshable={false}
                        showLabel={false}
                      />
                    </div>
                  )}
                </Link>
              );
            })}
          </Col>
        </Row>
      </div>
    </Container>
  );
}

ResearchByType.propTypes = {
  content: CmsEntities.Content.isRequired,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};
